import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=755962d6&scoped=true&"
import script from "./HeaderInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=755962d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755962d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
